// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dxugkesutduspnemswba.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR4dWdrZXN1dGR1c3BuZW1zd2JhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc5NDI3NDQsImV4cCI6MjA1MzUxODc0NH0.UCv6bvhcwt-cutBwF_iW500-8A3AChwJ8U3zhDr-h_4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);